export const WhatsappTemplateCategoryEnum = Object.freeze({
  UTILITY: 'UTILITY',
  MARKETING: 'MARKETING',
  LIMITED_TIME_OFFER: 'LIMITED_TIME_OFFER',
  CAROUSEL: 'CAROUSEL',
});